$(function(){
  //アラートのどこをクリックしても閉じられる
  $('.alert-dismissible').click(function() {
    $(this).hide();
  });

  //一定時間後に閉じる
  $('.alert-dismissible').delay(3000).slideUp(200, function() {
    $(this).hide();
  });
});